import React from "react";
import DataTablePage from "@/components/common/DataTablePage";

export default function LibraryPage() {
  return (
    <DataTablePage
      collection="content_library"
      eyebrow="Assets"
      title="Content Library"
      subtitle="Store approved copy, hooks, taglines and ad creatives. Generate new pieces in the AI Content Studio."
      emptyDefault={{ type: "Ad Copy", platform: "All", status: "draft" }}
      columns={[
        { key: "title", label: "Title", type: "text" },
        { key: "type", label: "Type", type: "select", options: ["Tagline", "Ad Copy", "Hook", "Caption", "Email", "Blog"] },
        { key: "platform", label: "Platform", type: "text" },
        { key: "status", label: "Status", type: "badge", options: ["draft", "approved"] },
        { key: "body", label: "Body", type: "textarea" },
        { key: "tags", label: "Tags", type: "text" },
      ]}
    />
  );
}
